exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.form-control[data-v-6faadf9c] {\n  margin-bottom: 10px;\n  height: 42px !important;\n  border-radius: 4px !important;\n}\n.select[data-v-6faadf9c] {\n  width: 100% !important;\n  height: 42px !important;\n  border-radius: 4px !important;\n}\nh4[data-v-6faadf9c] {\n  font-weight: bold !important;\n}\n.grid-title[data-v-6faadf9c] {\n  border-top: 1px solid #eee;\n}\n", ""]);

// exports
